import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ChevronRight({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M5.86108 1.94434L11.4166 7.49989L5.86108 13.0554"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
